import { Pipe, PipeTransform } from '@angular/core';

/**
 * a pipe which does string replacing
 */
@Pipe( {
    name: 'hisReplace',
    standalone: false
} )
export class HisReplacePipe implements PipeTransform {

    transform( value: string, ...params: any[] ): string {
        if ( value ) {
            return value.toString().replace( params[0], params[1] );
        }
        return '';
    }
}
